/**
 * Created by hj on 2017/9/25.
 */
import Reflux from 'reflux';
/**
 * 1、Store 和 Actions 的名称需要保持一致。要求这两个词的前缀或后缀相同。
 * 2、createActions接收的参数要和Store中的方法保持一致
 */
export const Actions = Reflux.createActions([
	'paramChange',
	'useStoreChange',
]);

export class Store extends Reflux.Store {
	constructor()
	{
		super();
		this.state = {
			useStore: false,
			params: {
				code: '',
				customerName: '',
				createTimeStart: '',
				createTimeEnd: '',
				areaId: '',
				buyerStatus: '',
				orderType: '',
				s: 10,
				p: 1
			}
		};
		this.listenables = Actions;
	}
	useStoreChange(flag){
		this.setState({
			...this.state,
			useStore: flag
		});
	}
	paramChange(data){
		this.setState({
			...this.state,
			params:{
				...this.state.params,
				...data
			}
		});
	}
}


// WEBPACK FOOTER //
// ./src/routes/product/store.js